import { notification } from 'antd';
import $$ from 'cmn-utils';
import Notification from './Notification';
import './antdNotice.less';

const prefixCls = 'antui-notification';
const defaultConfig = {
};

function notice(config, type, title) {
  if ($$.isObject(config)) {
    notification[type]({
      className: `${prefixCls} ${prefixCls}-${type}`,
      message: config.message || config.content,
      ...defaultConfig,
      ...config
    });
  } else {
    notification[type]({
      className: `${prefixCls} ${prefixCls}-${type}`,
      message: title,
      description: config,
      ...defaultConfig
    });
  }
}

export default class extends Notification {
  static success(config) {
    notice(config, 'success', window.language['common.notice.success']);
  }

  static error(config) {
    notice(config, 'error', window.language['common.notice.error']);
  }

  static info(config) {
    notice(config, 'info', window.language['common.notice.prompt']);
  }

  static warning(config) {
    notice(config, 'warning', window.language['common.notice.notice']);
  }

  static warn(config) {
    notice(config, 'warning', window.language['common.notice.notice']);
  }

  static close(key) {
    notification.close(key);
  }

  static destroy() {
    notification.destroy();
  }
}



// WEBPACK FOOTER //
// ./src/components/Notification/antdNotice.js